export interface ContactFormData {
  fullName: string;
  companyName: string;
  businessEmail: string;
  phoneNumber: string;
  country: string;
  serviceRequired: string;
  productCategory: string;
  estimatedQuantity: string;
  message: string;
  referenceFile: File | null;
  privacyPolicy: boolean;
}

export interface FormFieldProps {
  id: string;
  label: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
  className?: string;
}

export interface FileUploadProps {
  onFileSelect: (file: File | null) => void;
  selectedFile: File | null;
  error?: string;
}

export const SERVICE_OPTIONS = [
  { value: "", label: "Select a service" },
  { value: "custom-manufacturing", label: "Custom Manufacturing" },
  { value: "oem", label: "OEM Production" },
  { value: "private-label", label: "Private Label" },
  { value: "product-development", label: "Product Development" },
  { value: "export-solutions", label: "Export Solutions" },
  { value: "wholesale", label: "Wholesale Inquiry" },
  { value: "sampling", label: "Product Sampling" },
  { value: "other", label: "Other" },
] as const;

export const PRODUCT_CATEGORY_OPTIONS = [
  { value: "", label: "Select a category" },
  { value: "home-decor", label: "Home Décor" },
  { value: "furniture", label: "Furniture" },
  { value: "handicrafts", label: "Handicrafts" },
  { value: "textiles", label: "Textiles & Fabric" },
  { value: "metal-crafts", label: "Metal Crafts" },
  { value: "wooden-crafts", label: "Wooden Crafts" },
  { value: "gifts-novelties", label: "Gifts & Novelties" },
  { value: "other", label: "Other" },
] as const;

export const COUNTRY_OPTIONS = [
  { value: "", label: "Select a country" },
  { value: "US", label: "United States" },
  { value: "GB", label: "United Kingdom" },
  { value: "DE", label: "Germany" },
  { value: "FR", label: "France" },
  { value: "AU", label: "Australia" },
  { value: "CA", label: "Canada" },
  { value: "AE", label: "United Arab Emirates" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "IN", label: "India" },
  { value: "JP", label: "Japan" },
  { value: "CN", label: "China" },
  { value: "SG", label: "Singapore" },
  { value: "NL", label: "Netherlands" },
  { value: "IT", label: "Italy" },
  { value: "ES", label: "Spain" },
  { value: "other", label: "Other" },
] as const;